import { render, staticRenderFns } from "./MessageFiles.vue?vue&type=template&id=54d4f963&"
import script from "./MessageFiles.vue?vue&type=script&lang=js&"
export * from "./MessageFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports